// import { Directive, ElementRef, Input, Renderer2, OnChanges, SimpleChanges } from '@angular/core';

// @Directive({
//   selector: '[appTruncateLines]'
// })
// export class TruncateLinesDirective implements OnChanges {
//   @Input() appTruncateLines: number | null = null;
//   @Input() expanded: boolean = false;

//   constructor(private el: ElementRef, private renderer: Renderer2) {}

//   ngOnChanges(changes: SimpleChanges): void {
//     const element = this.el.nativeElement;
//     if (this.expanded) {
//       this.renderer.setStyle(element, 'max-height', 'none');
//       this.renderer.removeStyle(element, '-webkit-line-clamp');
//     } else {
//       this.renderer.setStyle(element, 'max-height', `${this.appTruncateLines! * 1.2}em`);
//       this.renderer.setStyle(element, '-webkit-line-clamp', this.appTruncateLines);
//     }
//   }
// }
// import { Directive, ElementRef, Input, Renderer2, OnChanges } from '@angular/core';

// @Directive({
//   selector: '[appTruncateLines]'
// })
// export class TruncateLinesDirective implements OnChanges {
//   // @Input() appTruncateLines: number = 3;
//   // @Input() expanded: boolean = false;
//   @Input('appTruncateLines') set maxLines(value: number) {
//    this._maxLines = value;
//   }
//   @Input() set expanded(expanded: boolean) {
//     if (expanded) {
//       this.renderer.removeStyle(this.el.nativeElement, '-webkit-line-clamp');
//     } else {
//       this.renderer.setStyle(this.el.nativeElement, '-webkit-line-clamp', this.maxLines);
//     }
//   }

//   private _maxLines:number = 2;
//   constructor(private el: ElementRef, private renderer: Renderer2) {}

//   ngOnChanges(): void {
//     if (this.expanded || !this._maxLines) {
//       this.renderer.removeStyle(this.el.nativeElement, 'max-height');
//       this.renderer.removeStyle(this.el.nativeElement, '-webkit-line-clamp');
//       this.renderer.removeStyle(this.el.nativeElement, 'display');
//       this.renderer.removeStyle(this.el.nativeElement, '-webkit-box-orient');
//     } else {
//       const lineHeight = parseFloat(getComputedStyle(this.el.nativeElement).lineHeight);
//       const maxHeight = `${lineHeight * this._maxLines}px`;
//       this.renderer.setStyle(this.el.nativeElement, 'max-height', maxHeight);
//       this.renderer.setStyle(this.el.nativeElement, 'display', '-webkit-box');
//       this.renderer.setStyle(this.el.nativeElement, '-webkit-box-orient', 'vertical');
//       this.renderer.setStyle(this.el.nativeElement, '-webkit-line-clamp', this._maxLines);
//     }
//   }
// }

import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appTruncateLines]',
})
export class TruncateLinesDirective {
  private _maxLines: number = 2;
  private _expanded: boolean = false;

  @Input('appTruncateLines') set maxLines(value: number) {
    this._maxLines = value || 2;
    this.updateStyles();
  }

  @Input() set expanded(value: boolean) {
    this._expanded = value;
    this.updateStyles();
  }

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  private updateStyles(): void {
    if (this._expanded) {
      this.renderer.removeStyle(this.el.nativeElement, '-webkit-line-clamp');
      this.renderer.removeStyle(this.el.nativeElement, 'display');
      this.renderer.removeStyle(this.el.nativeElement, '-webkit-box-orient');
    } else {
      this.renderer.setStyle(this.el.nativeElement, 'display', '-webkit-box');
      this.renderer.setStyle(
        this.el.nativeElement,
        '-webkit-box-orient',
        'vertical',
      );
      this.renderer.setStyle(
        this.el.nativeElement,
        '-webkit-line-clamp',
        this._maxLines,
      );
    }
  }
}
